export function value(x) {
    return () => x;
}
export default value;
